// Add your custom JS here.
window.Thermotile || (window.Thermotile = {});

window.thermotileInitAOS = window.thermotileInitAOS || function () {
    if (!window.AOS || typeof AOS.init !== 'function') {
        return;
    }

    if (window.__thermotileAOSInitialized) {
        if (typeof AOS.refreshHard === 'function') {
            AOS.refreshHard();
        } else if (typeof AOS.refresh === 'function') {
            AOS.refresh();
        }

        return;
    }

    AOS.init({
        duration: 600,
        once: false,
        mirror: true
    });
    window.__thermotileAOSInitialized = true;
};

window.thermotileRefreshAOS = window.thermotileRefreshAOS || (function () {
    var ticking = false;
    var needsHardRefresh = false;

    return function (hardRefresh) {
        needsHardRefresh = needsHardRefresh || !!hardRefresh;

        if (ticking) {
            return;
        }

        ticking = true;

        window.requestAnimationFrame(function () {
            window.requestAnimationFrame(function () {
                ticking = false;

                if (!window.AOS || typeof AOS.init !== 'function') {
                    return;
                }

                if (!window.__thermotileAOSInitialized) {
                    window.thermotileInitAOS();
                    needsHardRefresh = false;
                    return;
                }

                var hard = needsHardRefresh;
                needsHardRefresh = false;

                if (hard && typeof AOS.refreshHard === 'function') {
                    AOS.refreshHard();
                } else if (typeof AOS.refresh === 'function') {
                    AOS.refresh();
                }
            });
        });
    };
})();

(function ($) {

  /**
	 * jQuery Window Object
	 * 
	 * @var {jQuery} $window
	 * @since 1.0
	 */
	Thermotile.$window = $(window);

	/**
	 * jQuery Body Object
	 * 
	 * @var {jQuery} $body
	 * @since 1.0
	 */
	Thermotile.$body;

  /**
	 * Thermotile Theme Setup
	 */
	$(window).on('load', function () {
		// Body has been loaded.
		Thermotile.$body = $(document.body).addClass('loaded');
		// Touch is enabled?
		$('html').addClass('ontouchstart' in document ? 'touchable' : 'untouchable');
		Thermotile.initScrollTopButton();
	});
  /**
	 * Get DOM element by id
	 * 
	 * @since 1.0
	 * @param {string} id    ID attribute of element to find
	 * @return {HTMLElement} Matched element
	 */
	Thermotile.byId = function (id) {
		return document.getElementById(id);
	};
  /**
	 * Create a macro task
	 *
	 * @since 1.0
	 * @param {function} fn  Function to handle task.
	 * @param {number} delay Delay time
	 * @return {void}
	 */
	Thermotile.call = function (fn, delay) {
		delay ? setTimeout(fn, delay) : fn();
	}
  /**
	  * Scroll to given target in given duration.
	  *
	  * @since 1.0
	  * @param {mixed}  target   This can be number or string seletor or jQuery object.
	  * @param {number} duration This can be omitted.
	  * @return {void}
	  */

	  Thermotile.scrollTo = function (target, duration) {
	    var _duration = typeof duration == 'undefined' ? 0 : duration;

	    var offset;

	    if (typeof target == 'number') {
	      offset = target;
	    }

	    $('html,body').stop().animate({
	      scrollTop: offset
	    }, _duration);
	  };

   /**
	 * Initialize scroll to top button
	 * 
	 * @since 1.0
	 * @return {void}
	 */
	Thermotile.initScrollTopButton = function () {
		// register scroll top button
		var domScrollTop = Thermotile.byId('scroll-top');
		if (domScrollTop) {
			var progressIndicator = Thermotile.byId('progress-indicator');
			var scrollRange = 1;
			var scrollTopTicking = false;

			Thermotile.$body.on('click', '#scroll-top', function (e) {
				Thermotile.scrollTo(0);
				e.preventDefault();
			});

			function _refreshScrollMetrics() {
				scrollRange = Math.max(
					document.documentElement.scrollHeight - window.innerHeight,
					1
				);
			}

			function _renderScrollTop() {
				scrollTopTicking = false;
				_refreshScrollMetrics();

				if (window.scrollY > 200) { // issue: heavy js performance, 8.3ms
					domScrollTop.classList.add('show');

					// Show scroll position percent in scroll top button
					var perc = window.scrollY / scrollRange * 214;

					if (progressIndicator) {
						progressIndicator.style.strokeDasharray = perc + ', 400';
					}
				} else {
					domScrollTop.classList.remove('show');
				}
			}

			function _refreshScrollTop() {
				if (scrollTopTicking) {
					return;
				}

				scrollTopTicking = true;
				window.requestAnimationFrame(_renderScrollTop);
			}

			_refreshScrollMetrics();
			Thermotile.call(_refreshScrollTop, 500);
			Thermotile.refreshScrollTopButton = _refreshScrollTop;
			window.addEventListener('resize', function () {
				_refreshScrollMetrics();
				_refreshScrollTop();
			}, { passive: true });
			window.addEventListener('scroll', _refreshScrollTop, { passive: true });

			if (window.ResizeObserver) {
				var scrollTopResizeObserver = new ResizeObserver(_refreshScrollTop);
				scrollTopResizeObserver.observe(document.body);
				scrollTopResizeObserver.observe(document.documentElement);
			}

			if (window.MutationObserver) {
				var scrollTopMutationObserver = new MutationObserver(function () {
					_refreshScrollTop();
				});

				scrollTopMutationObserver.observe(document.body, {
					childList: true,
					subtree: true,
				});
			}

			$(document).on('facetwp-loaded ajaxComplete', _refreshScrollTop);
			$(window).on('load', _refreshScrollTop);
		}
	};

  var sidebarScrollTop = 0;
  var sidebarScrollLockClass = 'sidebar-scroll-locked';
  var sidebarScrollLockTarget = null;
  var sidebarScrollLockTargetStyles = null;

  function isMobileSidebarViewport() {
    return window.matchMedia('(max-width: 991.98px)').matches;
  }

  function hasOpenSidebar() {
    return $('.sidebar-content.show, .sidebar-content-right.show').length > 0;
  }

  function getSidebarScrollLockTarget() {
    return document.getElementById('page') || document.querySelector('.site') || document.body;
  }

  function lockSidebarScroll() {
    if (document.body.classList.contains(sidebarScrollLockClass)) {
      return;
    }

    sidebarScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
    sidebarScrollLockTarget = getSidebarScrollLockTarget();
    sidebarScrollLockTargetStyles = {
      position: sidebarScrollLockTarget.style.position,
      top: sidebarScrollLockTarget.style.top,
      left: sidebarScrollLockTarget.style.left,
      right: sidebarScrollLockTarget.style.right,
      width: sidebarScrollLockTarget.style.width
    };

    sidebarScrollLockTarget.style.position = 'fixed';
    sidebarScrollLockTarget.style.top = '-' + sidebarScrollTop + 'px';
    sidebarScrollLockTarget.style.left = '0';
    sidebarScrollLockTarget.style.right = '0';
    sidebarScrollLockTarget.style.width = '100%';
    document.documentElement.classList.add(sidebarScrollLockClass);
    document.body.classList.add(sidebarScrollLockClass);
  }

  function unlockSidebarScroll() {
    if (!document.body.classList.contains(sidebarScrollLockClass)) {
      return;
    }

    var scrollTop = sidebarScrollLockTarget
      ? Math.abs(parseInt(sidebarScrollLockTarget.style.top, 10)) || sidebarScrollTop
      : sidebarScrollTop;
    var htmlScrollBehavior = document.documentElement.style.scrollBehavior;
    var bodyScrollBehavior = document.body.style.scrollBehavior;

    document.documentElement.style.scrollBehavior = 'auto';
    document.body.style.scrollBehavior = 'auto';
    document.documentElement.classList.remove(sidebarScrollLockClass);
    document.body.classList.remove(sidebarScrollLockClass);
    if (sidebarScrollLockTarget && sidebarScrollLockTargetStyles) {
      sidebarScrollLockTarget.style.position = sidebarScrollLockTargetStyles.position;
      sidebarScrollLockTarget.style.top = sidebarScrollLockTargetStyles.top;
      sidebarScrollLockTarget.style.left = sidebarScrollLockTargetStyles.left;
      sidebarScrollLockTarget.style.right = sidebarScrollLockTargetStyles.right;
      sidebarScrollLockTarget.style.width = sidebarScrollLockTargetStyles.width;
    }
    sidebarScrollLockTarget = null;
    sidebarScrollLockTargetStyles = null;
    window.scrollTo(0, scrollTop);
    document.documentElement.style.scrollBehavior = htmlScrollBehavior;
    document.body.style.scrollBehavior = bodyScrollBehavior;
  }

  function syncSidebarScrollLock() {
    if (isMobileSidebarViewport() && hasOpenSidebar()) {
      lockSidebarScroll();
    } else {
      unlockSidebarScroll();
    }
  }

  $(window).on('resize', syncSidebarScrollLock);

  $(document).on('click touch', '.left-sidebar-toggle', function(e) {
    e.preventDefault();
		Thermotile.$body = $('.sidebar-content').addClass('show');
		Thermotile.$body = $('.sidebar-overlay').addClass('show');
		Thermotile.$body = $('.sidebar-close').addClass('show');
    syncSidebarScrollLock();
  });
  $(document).on('click touch', '.sidebar-close', function(e) {
    e.preventDefault();
    Thermotile.$body = $('.sidebar-content').removeClass('show');
    Thermotile.$body = $('.sidebar-overlay').removeClass('show');
    Thermotile.$body = $('.sidebar-close').removeClass('show');
    Thermotile.$body = $('.sidebar-content-right').removeClass('show');
    syncSidebarScrollLock();
  });
  $(document).on('click touch', '.sidebar-overlay', function(e) {
    e.preventDefault();
		Thermotile.$body = $('.sidebar-content').removeClass('show');
		Thermotile.$body = $('.sidebar-overlay').removeClass('show');
		Thermotile.$body = $('.sidebar-close').removeClass('show');
    Thermotile.$body = $('.sidebar-content-right').removeClass('show');
    syncSidebarScrollLock();
  });

  // Unlock the page before a mobile guide link performs its native anchor jump.
  $(document).on('click', '#proGuideToc nav a[href^="#"]', function(e) {
    if (!isMobileSidebarViewport() || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) {
      return;
    }
    if ($(this).closest('.sidebar-content').hasClass('show')) {
      $(this).closest('.pro-guide-sidebar').find('.sidebar-close').first().trigger('click');
    }
  });

  // Animation for title/headline scroll left/right 
  const titleAnimEls = Array.from(document.querySelectorAll('.title--anim'));
  const gridGalleryEls = Array.from(document.querySelectorAll('.grid--gallery'));

  if (titleAnimEls.length || gridGalleryEls.length) {
      let scrollAnimationTicking = false;

      function renderScrollAnimations() {
          scrollAnimationTicking = false;
          const winHeight = window.innerHeight || document.documentElement.clientHeight;
          const updates = [];

          titleAnimEls.forEach(function (element) {
              const rect = element.getBoundingClientRect();

              if (rect.top <= winHeight && rect.bottom >= 0) {
                  const center = rect.top + (rect.height / 2);
                  const titlePos = element.classList.contains('title--anim-left')
                      ? (100 / winHeight) * center
                      : (100 / winHeight) * (winHeight - center);

                  updates.push({
                      element,
                      transform: 'translateX(' + (Math.round(titlePos) - 50) + '%)'
                  });
              }
          });

          gridGalleryEls.forEach(function (element) {
              const rect = element.getBoundingClientRect();

              if (rect.top <= winHeight && rect.bottom >= 0) {
                  const titlePos = (100 / winHeight) * rect.top / 2;

                  updates.push({
                      element,
                      transform: 'translateX(' + Math.round(titlePos) + '%)'
                  });
              }
          });

          updates.forEach(function (update) {
              update.element.style.transform = update.transform;
          });
      }

      function requestScrollAnimationRender() {
          if (scrollAnimationTicking) {
              return;
          }

          scrollAnimationTicking = true;
          window.requestAnimationFrame(renderScrollAnimations);
      }

      window.addEventListener('scroll', requestScrollAnimationRender, { passive: true });
      window.addEventListener('resize', requestScrollAnimationRender, { passive: true });
      requestScrollAnimationRender();
  }
  
if ($('.tiles-grid').length) {
    $('.tiles-grid').each(function () {
        var $grid = $(this);
        var masonryOptions = {
            columnWidth: '.tile-item__sizer',
            gutter: '.tile-item__gutter',
            itemSelector: '.tile-item',
            percentPosition: true,
            stagger: 50
        };

        function refreshTileAnimations() {
            if (window.thermotileRefreshAOS) {
                window.thermotileRefreshAOS(true);
            } else if (window.thermotileInitAOS) {
                window.thermotileInitAOS();
            }
        }

        $grid.on('layoutComplete', refreshTileAnimations);
        $grid.masonry(masonryOptions);
        refreshTileAnimations();

        // Images can still shift masonry height; relayout and refresh AOS as each one settles.
        $grid.imagesLoaded()
            .progress(function () {
                $grid.masonry('layout');
            })
            .always(function () {
                $grid.masonry('layout');
                refreshTileAnimations();
        });
    });
}


function thermotileScheduleAfterFirstPaint(callback) {
  const run = () => {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(callback, { timeout: 1200 });
    } else {
      window.setTimeout(callback, 250);
    }
  };

  window.requestAnimationFrame(() => window.requestAnimationFrame(run));
}

window.thermotileScheduleAfterFirstPaint = thermotileScheduleAfterFirstPaint;

// Navigation
if (window.matchMedia('(min-width: 992px)').matches) {
  const $navigationDropdownMenus = $('.navigation .navbar-nav .dropdown-menu');

  $('.navbar-nav').removeClass('submenu');
  $('.reset-submenu').parent().removeClass('show');
  $('.nav-link').each( function(){
    $(this).addClass('show');
    $(this).parent().removeClass('open');
  });
  $navigationDropdownMenus.each( function(){
    $(this).addClass('show');
  });

  if ($('#navbarNavDropdown').length && window.SimpleBar) {
    thermotileScheduleAfterFirstPaint(function () {
      new SimpleBar(document.getElementById('navbarNavDropdown'));
    });
  }
}
if (window.matchMedia('(max-width: 991px)').matches) {
  const $navigationDropdownMenus = $('.navigation .navbar-nav .dropdown-menu');

  $navigationDropdownMenus.each(function () {
    if (!$(this).parent().hasClass('nav-sub')) {
      $(this).wrap("<div class='nav-sub'></div>");
    }
  });
  $('.nav-link').each( function(){
    $(this).removeClass('show');
  });
  $navigationDropdownMenus.each( function(){
    $(this).removeClass('show');
  });

  if (window.SimpleBar) {
    thermotileScheduleAfterFirstPaint(function () {
      $('.navigation .navbar-nav .nav-sub').each((index, element) => new SimpleBar(element));
    });
  }
}

$(document).on('click touch', '.reset-submenu', function(e) {
  e.preventDefault();
  e.stopPropagation(e);
  $('.nav-link').each( function(){
    $(this).removeClass('show');
    $(this).parent().removeClass('open');
  });
  $('.navigation .navbar-nav .dropdown-menu').each( function(){
    $(this).removeClass('show');
  });
  $('.navbar-nav').removeClass('submenu');
  $(this).removeClass('show');
  $('.navigation .sidenav').find('.icon-link').parent().removeClass('active');
});



// Navigation mobile
if (window.matchMedia('(max-width: 991px)').matches) {

    $(document).on('click touch', '.dropdown .nav-link', function(e) {
      e.preventDefault();
      e.stopPropagation(e);
      $('.nav-link').each( function(){
        if ($(this).hasClass('show')){
          $(this).removeClass('show');
        }
        if ($(this).parent().hasClass('open')){
          $(this).parent().removeClass('open');
        }    
      });
      $('.navigation .navbar-nav .dropdown-menu').each( function(){
        if ($(this).hasClass('show')){
          $(this).removeClass('show');
        }
      });
      if ($('.navbar-nav').hasClass('submenu')){
        $(this).removeClass('submenu');
      }
      if ($('.reset-submenu').hasClass('submenu')){
        $(this).removeClass('show');
      } 
      if (window.matchMedia('(max-width: 991px)').matches){
        $(this).addClass('show');
        $('.reset-submenu').addClass('show');
        $('.navbar-nav').addClass('submenu');
        $(this).parent().addClass('open');
        $('.navigation .sidenav').find('.icon-link').parent().removeClass('active');
      }
      var section = $(this).attr('title');
      $('.navigation .sidenav').find('.icon-link[data-nav="' + section + '"]').parent().addClass('active');
    });

    $(document).on('click touch', '.navigation .sidenav .icon-link', function (e) {
        e.preventDefault(e);
        var section = $(this).data('nav');
        if (!$(this).hasClass('active')) {
            $('.navigation .sidenav').find('.icon-link').parent().removeClass('active');
            $('.navigation .navbar-nav').find('.nav-link[title="' + section + '"]').trigger('click');
        }
    });
}

$(document).on('click touch', '.navigation .nav-link', function(e){
  if(! $(this).parent().hasClass('dropdown')) {
    e.preventDefault(e);
    e.stopPropagation(e);
    var target = $(this).attr('href');
    window.location = target;
  }
});

if ($('.filter-toggle-mobile').length) {
    let filterBtnTicking = false;

    function filterBtn() {
        filterBtnTicking = false;

        function inView() {
            const wrapper = document.querySelector('div.wrapper');

            if (!wrapper) {
                return false;
            }

            let rect = wrapper.getBoundingClientRect();
            return (
                rect.top <= window.innerHeight / 2 &&
                rect.bottom >= (window.innerHeight || document.documentElement.clientHeight)
            );
        }

        if (window.matchMedia("(max-width: 992px)").matches && inView()) {
            $('.filter-toggle-mobile').addClass('show');
        } else {
            $('.filter-toggle-mobile').removeClass('show');
        }
    };

    function requestFilterBtn() {
        if (filterBtnTicking) {
            return;
        }

        filterBtnTicking = true;
        window.requestAnimationFrame(filterBtn);
    }

    $(window).on('resize scroll', requestFilterBtn);
    requestFilterBtn();
    $('.filter-toggle-mobile').on('click', function () {
        $('.sidebar-content-right').toggleClass('show');
        $('.sidebar-overlay').toggleClass('show');
        $('.sidebar-close').toggleClass('show');
        syncSidebarScrollLock();
    });
}

})(jQuery);

window.thermotileScheduleAfterFirstPaint = window.thermotileScheduleAfterFirstPaint || function (callback) {
    window.requestAnimationFrame(() => window.requestAnimationFrame(callback));
};

window.thermotileInitSwiperWhenVisible = window.thermotileInitSwiperWhenVisible || function (selector, options) {
    if (!window.Swiper) {
        return;
    }

    const elements = typeof selector === 'string' ? document.querySelectorAll(selector) : [selector].filter(Boolean);

    elements.forEach(function (element) {
        if (element.swiper || element.__thermotileSwiperPending || element.classList.contains('swiper-initialized')) {
            return;
        }

        element.__thermotileSwiperPending = true;

        const init = function () {
            if (element.swiper || element.classList.contains('swiper-initialized')) {
                return;
            }

            new Swiper(element, typeof options === 'function' ? options(element) : options);

            if (window.thermotileRefreshAOS) {
                window.thermotileRefreshAOS(true);
            }

            if (window.imagesLoaded && window.thermotileRefreshAOS) {
                window.imagesLoaded(element, function () {
                    window.thermotileRefreshAOS(true);
                });
            }
        };

        if ('IntersectionObserver' in window) {
            const observer = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (!entry.isIntersecting) {
                        return;
                    }

                    observer.unobserve(entry.target);
                    window.thermotileScheduleAfterFirstPaint(init);
                });
            }, { rootMargin: '250px 0px' });

            observer.observe(element);
        } else {
            window.thermotileScheduleAfterFirstPaint(init);
        }
    });
};

window.thermotileInitWaterfallCards = window.thermotileInitWaterfallCards || function (root) {
    const scope = root || document;
    const sliders = scope.querySelectorAll('.waterfall-card__slider');

    sliders.forEach(function (slider) {
        window.thermotileInitSwiperWhenVisible(slider, function (element) {
            const prevEl = element.querySelector('.swiper-button-prev');
            const nextEl = element.querySelector('.swiper-button-next');
            const paginationEl = element.querySelector('.swiper-pagination');
            const hasMultipleSlides = element.querySelectorAll('.swiper-slide').length > 1;
            const options = {
                slidesPerView: 1,
                loop: hasMultipleSlides,
                speed: 500,
                watchOverflow: true,
                observer: true,
                observeParents: true,
                resizeObserver: true,
                roundLengths: true,
                threshold: 6,
                zoom: {
                    maxRatio: 4,
                    minRatio: 1,
                    limitToOriginalSize: false,
                    toggle: true
                }
            };

            if (hasMultipleSlides && prevEl && nextEl) {
                options.navigation = {
                    nextEl: nextEl,
                    prevEl: prevEl,
                    addIcons: false
                };
            }

            if (hasMultipleSlides && paginationEl) {
                options.pagination = {
                    el: paginationEl,
                    type: 'bullets',
                    clickable: true
                };
            }

            return options;
        });
    });

    const waterfallFocusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

    function focusWaterfallElement(element) {
        if (!element || typeof element.focus !== 'function') {
            return;
        }

        try {
            element.focus({ preventScroll: true });
        } catch (error) {
            element.focus();
        }
    }

    function getWaterfallPanelFocusTarget(panel, preferredSelector) {
        if (!panel) {
            return null;
        }

        return panel.querySelector(preferredSelector) || panel.querySelector(waterfallFocusableSelector);
    }

    function setWaterfallHiddenState(element, isHidden) {
        if (!element) {
            return;
        }

        element.setAttribute('aria-hidden', isHidden ? 'true' : 'false');

        if (isHidden) {
            element.setAttribute('inert', '');
        } else {
            element.removeAttribute('inert');
        }
    }

    function setWaterfallPanelVisibility(panel, isVisible) {
        if (!panel) {
            return;
        }

        if (isVisible) {
            panel.hidden = false;
            setWaterfallHiddenState(panel, false);
        } else {
            setWaterfallHiddenState(panel, true);
            panel.hidden = true;
        }
    }

    function setWaterfallCardSpecState(card, showSpecs) {
        const description = card.querySelector('.waterfall-card__panel--description');
        const specs = card.querySelector('.waterfall-card__panel--specs');
        const toggle = card.querySelector('.waterfall-card__spec-toggle');

        if (!description || !specs) {
            return;
        }

        const panelToShow = showSpecs ? specs : description;
        const panelToHide = showSpecs ? description : specs;
        const activeElement = document.activeElement;
        const moveFocus = activeElement && panelToHide.contains(activeElement);
        const fallbackFocusTarget = card.querySelector('.waterfall-card__toggle');
        const focusTarget = showSpecs
            ? getWaterfallPanelFocusTarget(specs, '.waterfall-card__spec-back')
            : getWaterfallPanelFocusTarget(description, '.waterfall-card__spec-toggle');

        card.classList.toggle('is-showing-specs', showSpecs);
        setWaterfallPanelVisibility(panelToShow, true);

        if (moveFocus) {
            focusWaterfallElement(focusTarget || fallbackFocusTarget);
        }

        setWaterfallPanelVisibility(panelToHide, false);

        if (toggle) {
            toggle.setAttribute('aria-expanded', showSpecs ? 'true' : 'false');
        }
    }

    function setWaterfallCardState(card, isActive) {
        const button = card.querySelector('.waterfall-card__toggle');
        const overlay = card.querySelector('.waterfall-card__overlay');

        card.classList.toggle('is-active', isActive);

        if (!isActive) {
            setWaterfallCardSpecState(card, false);
        }

        if (button) {
            button.setAttribute('aria-expanded', isActive ? 'true' : 'false');
        }

        if (overlay) {
            if (!isActive && document.activeElement && overlay.contains(document.activeElement)) {
                focusWaterfallElement(button);
            }

            setWaterfallHiddenState(overlay, !isActive);
        }
    }

    function closeOpenWaterfallCards(exceptCard) {
        document.querySelectorAll('.waterfall-card.is-active').forEach(function (openCard) {
            if (exceptCard && openCard === exceptCard) {
                return;
            }

            setWaterfallCardState(openCard, false);
        });
    }

    function closeWhenTouchingAnotherWaterfallCard(event) {
        if (event.target.closest('.waterfall-card__toggle')) {
            return;
        }

        const card = event.target.closest('.waterfall-card');

        if (!card) {
            return;
        }

        const activeCard = document.querySelector('.waterfall-card.is-active');

        if (!activeCard || activeCard === card) {
            return;
        }

        closeOpenWaterfallCards(card);
    }

    scope.querySelectorAll('.waterfall-card').forEach(function (card) {
        setWaterfallCardState(card, card.classList.contains('is-active'));
    });

    if (document.__thermotileWaterfallCardsBound) {
        return;
    }

    document.__thermotileWaterfallCardsBound = true;

    if (window.PointerEvent) {
        document.addEventListener('pointerdown', closeWhenTouchingAnotherWaterfallCard);
    } else {
        document.addEventListener('touchstart', closeWhenTouchingAnotherWaterfallCard, { passive: true });
        document.addEventListener('mousedown', closeWhenTouchingAnotherWaterfallCard);
    }

    document.addEventListener('click', function (event) {
        const specToggle = event.target.closest('.waterfall-card__spec-toggle');

        if (specToggle) {
            event.preventDefault();

            const card = specToggle.closest('.waterfall-card');

            if (!card) {
                return;
            }

            closeOpenWaterfallCards(card);
            setWaterfallCardState(card, true);
            setWaterfallCardSpecState(card, true);
            return;
        }

        const specBack = event.target.closest('.waterfall-card__spec-back');

        if (specBack) {
            event.preventDefault();

            const card = specBack.closest('.waterfall-card');

            if (!card) {
                return;
            }

            setWaterfallCardSpecState(card, false);
            return;
        }

        const button = event.target.closest('.waterfall-card__toggle');

        if (!button) {
            return;
        }

        const card = button.closest('.waterfall-card');

        if (!card) {
            return;
        }

        const shouldOpen = !card.classList.contains('is-active');

        closeOpenWaterfallCards(card);

        if (shouldOpen) {
            setWaterfallCardState(card, true);
        } else {
            setWaterfallCardState(card, false);
        }
    });

    document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') {
            return;
        }

        closeOpenWaterfallCards();
    });
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
        window.thermotileInitWaterfallCards();
    });
} else {
    window.thermotileInitWaterfallCards();
}

function setNavItemHeight() {
    if (window.innerWidth <= 991) {
        const nav = document.querySelector('.navigation .navbar-nav');
        const side = document.querySelector('.navigation .sidenav');

        if (nav) {
            const count = nav.children.length;
            nav.style.setProperty('--nav-items', count);
        }

        if (side) {
            const count = side.children.length;
            side.style.setProperty('--nav-items', count);
        }
    }
}

let navItemHeightTicking = false;

function requestNavItemHeight() {
    if (navItemHeightTicking) {
        return;
    }

    navItemHeightTicking = true;
    window.requestAnimationFrame(function () {
        navItemHeightTicking = false;
        setNavItemHeight();
    });
}

// Run on load + resize
window.addEventListener('load', requestNavItemHeight);
window.addEventListener('resize', requestNavItemHeight, { passive: true });

window.thermotileScheduleAfterFirstPaint(window.thermotileInitAOS);

(function () {
    function refreshAOS() {
        if (window.thermotileRefreshAOS) {
            window.thermotileRefreshAOS(true);
        }
    }

    function bindAOSLayoutRefresh() {
        if ('ResizeObserver' in window) {
            const observer = new ResizeObserver(refreshAOS);
            [document.body, document.documentElement].forEach(function (element) {
                if (element) {
                    observer.observe(element);
                }
            });

            document.querySelectorAll('.brands-slider, .tiles-grid, .swiper').forEach(function (element) {
                observer.observe(element);
            });
        }

        document.querySelectorAll('img').forEach(function (image) {
            if (!image.complete) {
                image.addEventListener('load', refreshAOS, { once: true });
            }
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', bindAOSLayoutRefresh);
    } else {
        bindAOSLayoutRefresh();
    }

    window.addEventListener('load', function () {
        refreshAOS();
        window.setTimeout(refreshAOS, 250);
        window.setTimeout(refreshAOS, 1000);
    });
})();

function thermotileBindSwiperAutoplayToggle(swiper, rootSelector) {
    const root = typeof rootSelector === 'string' ? document.querySelector(rootSelector) : rootSelector;

    if (!swiper || !root) {
        return;
    }

    const toggleButton = root.querySelector('.swiper-button-toggle');

    if (!toggleButton || toggleButton.__thermotileAutoplayToggleBound) {
        return;
    }

    toggleButton.__thermotileAutoplayToggleBound = true;

    const playLabel = toggleButton.getAttribute('data-label-play') || 'Play';
    const pauseLabel = toggleButton.getAttribute('data-label-pause') || 'Pause';
    const canToggleAutoplay = swiper.autoplay &&
        typeof swiper.autoplay.start === 'function' &&
        typeof swiper.autoplay.stop === 'function';

    const isAutoplayRunning = function () {
        return !!(swiper.autoplay && swiper.autoplay.running);
    };

    const updateButtonState = function () {
        const isPaused = !isAutoplayRunning();
        const label = isPaused ? playLabel : pauseLabel;

        toggleButton.classList.toggle('is-paused', isPaused);
        toggleButton.setAttribute('aria-pressed', isPaused ? 'true' : 'false');
        toggleButton.setAttribute('aria-label', label);
        toggleButton.setAttribute('title', label);
        root.classList.toggle('is-autoplay-paused', isPaused);
    };

    if (!canToggleAutoplay) {
        toggleButton.disabled = true;
        updateButtonState();
        return;
    }

    toggleButton.addEventListener('click', function () {
        if (isAutoplayRunning()) {
            swiper.autoplay.stop();
        } else {
            swiper.autoplay.start();
        }

        updateButtonState();
    });

    swiper.on('autoplayStart', updateButtonState);
    swiper.on('autoplayStop', updateButtonState);
    swiper.on('autoplayPause', updateButtonState);
    swiper.on('autoplayResume', updateButtonState);

    updateButtonState();
    window.setTimeout(updateButtonState, 0);
}

if (window.Swiper && document.querySelector(".homepage-swiper")) {
    window.thermotileInitSwiperWhenVisible(".homepage-swiper", {
        speed: 3000,
        effect: "fade",
        fadeEffect: {
            crossFade: true
        },
        slidesPerView: 1,
        navigation: {
            nextEl: ".homepage-swiper .swiper-button-next",
            prevEl: ".homepage-swiper .swiper-button-prev",
            addIcons: false,
        },
        autoplay: {
            enabled: true,
            delay: 6000,
        },
        loop: false,
        pagination: {
            el: ".homepage-swiper .swiper-pagination",
            type: "bullets",
            clickable: true,
        },
        on: {
            init: function () {
                thermotileBindSwiperAutoplayToggle(this, ".homepage-swiper");
            },
        },
    });
}

if (window.Swiper && document.querySelector(".homepage-promo-swiper")) {
    window.thermotileInitSwiperWhenVisible(".homepage-promo-swiper", {
        speed: 700,
        slidesPerView: 1,
        autoHeight: true,
        loop: false,
        watchOverflow: true,
        threshold: 8,
        navigation: {
            nextEl: ".homepage-promo-swiper .swiper-button-next",
            prevEl: ".homepage-promo-swiper .swiper-button-prev",
            addIcons: false,
        },
        pagination: {
            el: ".homepage-promo-swiper .swiper-pagination",
            type: "bullets",
            clickable: true,
        },
    });
}


if (window.Swiper && document.querySelector(".cladding-swiper")) {
    window.thermotileInitSwiperWhenVisible(".cladding-swiper", {
        speed: 3000,
        effect: "fade",
        fadeEffect: {
            crossFade: true
        },
        slidesPerView: 1,
        navigation: {
            nextEl: ".cladding-swiper .swiper-button-next",
            prevEl: ".cladding-swiper .swiper-button-prev",
            addIcons: false,
        },
        autoplay: {
            delay: 5000,
        },
        loop: true,
        pagination: {
            el: ".cladding-swiper .swiper-pagination",
            type: "bullets",
            clickable: true,
        },

    });
}


if (window.Swiper && document.querySelector(".brands-slider")) {
    window.thermotileInitSwiperWhenVisible(".brands-slider", {
    	slidesPerView: 1,
      spaceBetween: 30,
    	navigation: {
    		nextEl: ".brands-slider .swiper-button-next",
    		prevEl: ".brands-slider .swiper-button-prev",
    		addIcons: false,
    	},
    	pagination: {
    		el: '.brands-slider .swiper-pagination',
    		type: 'bullets',
    		clickable: true,
    	},
    	loop: false,
      breakpoints: {
    		576: {
    			slidesPerView: 1,
    		},
    		768: {
    			slidesPerView: 2,
    		},
    		992: {
    			slidesPerView: 3,
    		},
    	},
    });
}

document.addEventListener('DOMContentLoaded', function () {
    if (!window.Swiper) {
        return;
    }

    if (document.querySelector('.brand-slider')) {
        window.thermotileInitSwiperWhenVisible('.brand-slider', {
            slidesPerView: 3,
            spaceBetween: 10,
            loop: true,
            autoplay: {
                delay: 3000,
                    disableOnInteraction: false,
                },
            breakpoints: {
                576: {
                    slidesPerView: 4,
                    spaceBetween: 15,
                },
                768: {
                    slidesPerView: 5,
                    spaceBetween: 20,
                },
                992: {
                    slidesPerView: 6,
                    spaceBetween: 30,
                },
            },
        });
    }

    if (document.querySelector('.products-brand-slider')) {
        window.thermotileInitSwiperWhenVisible('.products-brand-slider', {
            slidesPerView: 3,
            spaceBetween: 10,
            loop: true,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
            breakpoints: {
                576: {
                    slidesPerView: 3,
                    spaceBetween: 15,
                },
                768: {
                    slidesPerView: 4,
                    spaceBetween: 20,
                },
            },
        });
    }
});


document.addEventListener('DOMContentLoaded', function () {
    let youtubePlayers = [];
    let vimeoPlayers = [];

    // Pause all videos function
    function pauseAllVideos() {
        youtubePlayers.forEach(player => {
            if (player && typeof player.pauseVideo === 'function') {
                player.pauseVideo();
            }
        });

        vimeoPlayers.forEach(player => {
            if (player && typeof player.pause === 'function') {
                player.pause().catch(() => {});
            }
        });
    }

    // Initialize Swiper
    if (window.Swiper && document.querySelector('.single-product-slider')) {
        document.querySelectorAll('.single-product-slider').forEach(slider => {
            const controls = slider.nextElementSibling && slider.nextElementSibling.classList.contains('single-product-slider__controls')
                ? slider.nextElementSibling
                : slider;
            const paginationEl = controls.querySelector('.swiper-pagination');
            const nextEl = controls.querySelector('.swiper-button-next');
            const prevEl = controls.querySelector('.swiper-button-prev');
            const hasMultipleSlides = slider.querySelectorAll('.swiper-slide').length > 1;

            if (controls !== slider) {
                controls.hidden = !hasMultipleSlides;
            }

            const sliderOptions = {
                slidesPerView: 1,
                loop: hasMultipleSlides,
                watchOverflow: true,
                observer: true,
                observeParents: true,
                resizeObserver: true,
                on: {
                    init: function () {
                        if (controls !== slider) {
                            controls.hidden = !hasMultipleSlides;
                        }
                    },
                    slideChange: pauseAllVideos,
                },
            };

            if (hasMultipleSlides && paginationEl) {
                sliderOptions.pagination = {
                    el: paginationEl,
                    clickable: true,
                };
            }

            if (hasMultipleSlides && nextEl && prevEl) {
                sliderOptions.navigation = {
                    nextEl: nextEl,
                    prevEl: prevEl,
                    addIcons: false,
                };
            }

            window.thermotileInitSwiperWhenVisible(slider, sliderOptions);
        });
    }

    // Initialize YouTube players
    function initializeYouTubePlayers() {
        if (!window.YT || typeof YT.Player !== 'function') {
            return;
        }

        document.querySelectorAll('.video-container[data-type="youtube"]').forEach(container => {
            if (!container.__ytPlayer) {
                let videoId = null;

                try {
                    videoId = new URL(container.dataset.url, window.location.origin).searchParams.get('v');
                } catch (error) {
                    videoId = null;
                }

                if (!videoId) {
                    return;
                }

                const player = new YT.Player(container, {
                    height: '360',
                    width: '640',
                    videoId: videoId,
                });
                container.__ytPlayer = player;
                youtubePlayers.push(player);
            }
        });
    }

    // Initialize Vimeo players
    function initializeVimeoPlayers() {
        if (!window.Vimeo || typeof Vimeo.Player !== 'function') {
            return;
        }

        document.querySelectorAll('.video-container[data-type="vimeo"]').forEach(container => {
            if (!container.__vimeoPlayer) {
                const player = new Vimeo.Player(container, {
                    url: container.dataset.url,
                    width: 640,
                });
                container.__vimeoPlayer = player;
                vimeoPlayers.push(player);
            }
        });
    }

    // Initialize YouTube and Vimeo API
    function onYouTubeIframeAPIReady() {
        initializeYouTubePlayers();
    }

    function onVimeoAPIReady() {
        initializeVimeoPlayers();
    }

    window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;
    window.onVimeoAPIReady = onVimeoAPIReady;

    // Intersection Observer setup for pausing videos when slides are not visible
    if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (!entry.isIntersecting) {
                    pauseAllVideos();  // Pause videos when slide is not in view
                }
            });
        }, { threshold: 0.5 });

        document.querySelectorAll('.single-product-slider .swiper-slide').forEach(slide => {
            observer.observe(slide);
        });
    }

    // Ensure players are initialized on page load
    onYouTubeIframeAPIReady();
    onVimeoAPIReady();
});


// Look for .hamburger
var hamburger = document.querySelector(".hamburger");
var headerLogo = document.getElementById("headerLogoStart");
var navbar = document.getElementById('navigation');
if (hamburger) {
    hamburger.addEventListener("click", function() {
        document.getElementsByTagName('html')[0].classList.toggle("overflow");
        hamburger.classList.toggle("is-active");

        if (navbar) {
            navbar.classList.toggle("open");
        }

        if (headerLogo) {
            headerLogo.classList.toggle("start");
        }
    });
}

const body = document.body;
const nav = document.querySelector(".site header");
const scrollUp = "scroll-up";
const scrollDown = "scroll-down";
let lastScroll = 10;
let scrollDistTicking = false;

function scrollDist() {
    scrollDistTicking = false;

    const currentScroll = window.pageYOffset;
    if (currentScroll <= 10) {
        body.classList.remove(scrollUp);
        return;
    }

    if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
        // down
        body.classList.remove(scrollUp);
        body.classList.add(scrollDown);
    } else if (
        currentScroll < lastScroll &&
        body.classList.contains(scrollDown)
    ) {
        // up
        body.classList.remove(scrollDown);
        body.classList.add(scrollUp);
    }
    lastScroll = currentScroll;
}

function requestScrollDist() {
    if (scrollDistTicking) {
        return;
    }

    scrollDistTicking = true;
    window.requestAnimationFrame(scrollDist);
}

window.addEventListener("scroll", requestScrollDist, { passive: true } );

window.addEventListener("load", requestScrollDist );



function accordionBuild(el) {
  if (!el) return;

  el.classList.add('js-accordion');
  el.setAttribute('id', 'accordionGroup');
  el.setAttribute('role', 'presentation');
  Array.from(el.querySelectorAll('.nav-multi-col__column')).forEach(function (column) {
    const panel = column.querySelector('.nav-multi-col__panel');
    const title = column.querySelector('.nav-multi-col__heading');

    if (!panel || !title || !title.parentElement) {
      return;
    }

    panel.classList.add('hidden');
    panel.classList.add('js-accordion-panel');
    title.parentElement.classList.add('js-accordion-trigger');
    title.classList.add('js-accordion-title');
  });
}

function accordionDestroy(el) {
  if (!el) return;

  el.classList.remove('js-accordion');
  el.removeAttribute('id');
  el.removeAttribute('role');
  Array.from(el.querySelectorAll('.nav-multi-col__column')).forEach(function (column) {
    const panel = column.querySelector('.nav-multi-col__panel');
    const title = column.querySelector('.nav-multi-col__heading');

    if (!panel || !title || !title.parentElement) {
      return;
    }

    panel.classList.remove('hidden');
    panel.classList.remove('js-accordion-panel');
    title.parentElement.classList.remove('js-accordion-trigger');
    title.classList.remove('js-accordion-title');
  });
}

function toggleAccordion() {
  const accordion = document.querySelector('.nav-multi-col');
  if (!accordion) {
    return;
  }

  if (window.matchMedia("(max-width: 768px)").matches) {
    accordionBuild(accordion);
    accordion.removeEventListener('click', handleAccordionClick);
    accordion.addEventListener('click', handleAccordionClick);
  } else {
    accordionDestroy(accordion);
    accordion.removeEventListener('click', handleAccordionClick);
  }
}

function handleAccordionClick(event) {
  const target = event.target.closest('.js-accordion-trigger');
  if (!target) return;

  const isExpanded = target.getAttribute('aria-expanded') === 'true';
  const panel = document.getElementById(target.getAttribute('aria-controls'));

  if (isExpanded) {
    target.setAttribute('aria-expanded', 'false');
    panel.classList.add('hidden');
    target.querySelector('.lni').classList.replace('w-icon-angle-up', 'w-icon-angle-down');
  } else {
    target.setAttribute('aria-expanded', 'true');
    panel.classList.remove('hidden');
    target.querySelector('.lni').classList.replace('w-icon-angle-down', 'w-icon-angle-up');
  }

  event.preventDefault();
}

let accordionTicking = false;

function requestToggleAccordion() {
  if (accordionTicking) {
    return;
  }

  accordionTicking = true;
  window.requestAnimationFrame(function () {
    accordionTicking = false;
    toggleAccordion();
  });
}

// Initialize on load and on resize
window.addEventListener('load', requestToggleAccordion);
window.addEventListener('resize', requestToggleAccordion, { passive: true });



(function($) {
	//"use strict";
	//$(function() {

		//-----------------------------------------------------
		// [2] Ajax load products - On Click
		//-----------------------------------------------------
		//$('#pp_loadmore_products').click(function(){

		//	var button = $(this),
		//	    data = {
		//		'action': 'loadmore',
		//		'query': wp_js_vars.posts, // that's how we get params from wp_localize_script() function
		//		'page' : wp_js_vars.current_page
		//	};

		//	$.ajax({
		//		url : wp_js_vars.ajaxurl, // AJAX handler
		//		data : data,
		//		related_products : 'no',
		//		type : 'POST',
		//		beforeSend : function ( xhr ) {
		//			button.addClass('loading');
		//			button.text('LOADING ...'); // change the button text, you can also add a preloader image
		//		},
		//		success : function( data ){
		//			if( data ) {
		//				//console.log('current_page: ' + wp_js_vars.current_page + ' max_page: ' + wp_js_vars.max_page);
		//				$('.products__grid').append( data ); // where to insert posts
		//				button.removeClass('loading');
		//				button.text( 'Load more' );
		//				wp_js_vars.current_page++;

		//				if ( wp_js_vars.current_page == wp_js_vars.max_page )
		//					button.remove(); // if last page, remove the button
		//			} else {
		//				button.remove(); // if no data, remove the button as well
		//			}
		//		}
		//	});
	//	});

	//});
  

if ($.fn.magnificPopup && $('.refil__left').length) {
$('.refil__left').magnificPopup({   
   //disableOn: 700, 
   type: 'iframe', 
   mainClass: 'mfp-fade', 
   removalDelay: 160, 
   preloader: false, 
   fixedContentPos: false,  
   gallery: {
  enabled: true, // set to true to enable gallery
  preload: [1,3], // read about this option in next Lazy-loading section
  navigateByImgClick: true,
  arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>', // markup of an arrow button
  tPrev: 'Previous (Left arrow key)', // title for left button
  tNext: 'Next (Right arrow key)', // title for right button
  tCounter: '<span class="mfp-counter">%curr% of %total%</span>' // markup of counter
  },
  iframe: {
		markup: '<div class="mfp-iframe-scaler">' +
			'<div class="mfp-close"></div>' +
			'<iframe class="mfp-iframe" frameborder="0" allow="autoplay"></iframe>' +
			'</div>',
		patterns: {
			youtube: {
				index: 'youtube.com/',
				id: 'v=',
				src: 'https://www.youtube.com/embed/%id%?autoplay=1'
			}
		}
	}
});
}

$(document).on('click touch', '.product-video__play-button', function(e) {
    e.preventDefault();
    $('[data-youtube]').youtube_background();
    Thermotile.$body = $('.js-productFullVideo').addClass('video--started'); 
  });
$(document).on('click touch', '.video--started', function(e) {
    e.preventDefault();
  });

if ($('.product__container').length) {
  var productGalleryRatioUpdate = null;
  var $productGalleries = $('.woocommerce-product-gallery.images');

  function updateProductGalleryRatio($gallery) {
      var $image = $gallery.find('.woocommerce-product-gallery__image.flex-active-slide img').first();

      if (!$image.length) {
          $image = $gallery.find('.woocommerce-product-gallery__image img').first();
      }

      if (!$image.length) {
          $image = $gallery.find('img').first();
      }

      var image = $image.get(0);

      if (!image || !image.complete || !image.naturalHeight) {
          return;
      }

      $gallery.toggleClass('product-gallery--extra-wide', image.naturalWidth / image.naturalHeight > 2);
  }

  function scheduleProductGalleryRatioUpdate() {
      if (productGalleryRatioUpdate) {
          window.cancelAnimationFrame(productGalleryRatioUpdate);
      }

      productGalleryRatioUpdate = window.requestAnimationFrame(function () {
          $productGalleries.each(function () {
              updateProductGalleryRatio($(this));
          });
      });
  }

  $productGalleries.each(function () {
      var gallery = this;
      var observer = new MutationObserver(scheduleProductGalleryRatioUpdate);

      observer.observe(gallery, {
          attributes: true,
          attributeFilter: ['class', 'src', 'srcset'],
          childList: true,
          subtree: true
      });
  });

  document.addEventListener('load', function (event) {
      if (event.target.matches && event.target.matches('.woocommerce-product-gallery.images img')) {
          scheduleProductGalleryRatioUpdate();
      }
  }, true);

  $('.variations_form').on('found_variation reset_data', scheduleProductGalleryRatioUpdate);
  scheduleProductGalleryRatioUpdate();

  $('.product__colors-field').on('click', function (e) {
      e.preventDefault();
      if (!$(this).hasClass('active')) {
          $('.product__colors .product__colors-field').removeClass('active');
          $(this).addClass('active');
          var color = $(this).data('color');
          $('.product__image .product__image--color').removeClass('active');
          $('.product__image .product__image--color').each(function () {
              if ($(this).attr('data-color') == color) {
                  $(this).addClass('active');
              }
          });
      }
  });
  if ($('.product__features').length) {
    $('.toggle-features').on('click', function (e) {
        e.preventDefault();
        var feature = $(this).data('feature');
        $('.product__features--feature').fadeOut();
        $('.product__features--feature[data-feature="'+feature+'"]').fadeIn();
        $(this).slideUp();
        $('.toggle-features[data-feature!="'+feature+'"]').slideDown();

    });
    $('.product__feature .toggle-details').on('click', function (e) {
        e.preventDefault();
        var details = $(this).parents('.product__feature').children('.product__feature-detail');
        if(details.hasClass('show')) {
            details.removeClass('show');
        } else {
            $('.product__feature-detail').removeClass('show');
            details.addClass('show');
            if(details.find('.video').length) {
                const video = new Plyr(details.find('.video'), {
                    controls: ['play-large', 'fullscreen'],
                    volume: 0,
                    muted: true,
                });
                video.play();
            }
        }
    });
  }
}

// Video Plyr
if ($('.video-player').length) {
    $('.video-player').each(function () {
        let ctrlsPlayer = ['play-large'];
        if ($(this).attr('controls')) {
            ctrlsPlayer.push('play', 'progress');
        }
        ctrlsPlayer.push('mute', 'volume');
        if ($(this).attr('controls')) {
            ctrlsPlayer.push('settings');
        }
        ctrlsPlayer.push('fullscreen');
        const player = new Plyr($(this), {
            controls: ctrlsPlayer,
        });
        if ($(this).hasClass('play')) {
            player.play();
        }

    });
}
if ($('.start-slider').length) {
    window.thermotileInitSwiperWhenVisible('.start-slider', {
        speed: 600,
        effect: 'fade',
        loop: false,
        lazy: true,
        autoplay: {
            delay: 9000,
        },
        keyboard: {
            enabled: true,
        },
        navigation: {
            nextEl: '.start-slider .swiper-button-next',
            prevEl: '.start-slider .swiper-button-prev',
            addIcons: false,
        },
        pagination: {
            el: '.start-slider .swiper-pagination',
            clickable: true,
        },
    });
}

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.swiper-container').forEach(function (element) {
        if (
            element.classList.contains('homepage-swiper') ||
            element.classList.contains('cladding-swiper') ||
            element.classList.contains('brands-slider') ||
            element.classList.contains('single-product-slider') ||
            element.classList.contains('start-slider') ||
            element.classList.contains('brand-slider') ||
            element.classList.contains('products-brand-slider') ||
            element.classList.contains('swiper-initialized')
        ) {
            return;
        }

        window.thermotileInitSwiperWhenVisible(element, {
            loop: true,
            pagination: {
                el: element.querySelector('.swiper-pagination'),
                clickable: true,
            },
            navigation: {
                nextEl: element.querySelector('.swiper-button-next'),
                prevEl: element.querySelector('.swiper-button-prev'),
                addIcons: false,
            },
        });
    });
});

function thermotileAddFacetSearchInputIds() {
  $('.facetwp-facet[data-type="search"], .facetwp-facet.facetwp-type-search').each(function(facetIndex) {
    var facet = $(this);
    var facet_name = facet.attr('data-name') || 'search';
    var safe_facet_name = facet_name.toLowerCase().replace(/[^a-z0-9_-]+/g, '-').replace(/^-+|-+$/g, '') || 'search';

    facet.find('input.facetwp-search').each(function(inputIndex) {
      var index_suffix = facetIndex || inputIndex ? '-' + (facetIndex + 1) + (inputIndex ? '-' + (inputIndex + 1) : '') : '';
      var field_label = this.getAttribute('placeholder') || (window.FWP && FWP.settings && FWP.settings.labels && FWP.settings.labels[facet_name]) || '';

      if (!this.id) {
        this.id = 'facetwp-' + safe_facet_name + '-search' + index_suffix;
      }

      if (field_label && !this.getAttribute('aria-label')) {
        this.setAttribute('aria-label', field_label);
      }
    });
  });
}

$(thermotileAddFacetSearchInputIds);
$(document).on('facetwp-loaded', thermotileAddFacetSearchInputIds);

$(document).on('facetwp-loaded', function() {
  $('.facetwp-facet').each(function() {
    var facet = $(this);
    var facet_name = facet.attr('data-name');
    var facet_type = facet.attr('data-type');
    var facet_label = FWP.settings.labels[facet_name];
    if (facet_type !== 'pager' && facet_type !== 'sort' && facet_type !== 'reset' && facet_type !== 'search') {
      if (facet.closest('.facet-wrap').length < 1 && facet.closest('.facetwp-flyout').length < 1) {
        facet.wrap('<div class="facet-wrap"></div>');
        facet.before('<h4 class="facet-label" style="display:none;">' + facet_label + '</h4>');
        facet.wrap('<div class="facet-wrapper facet-wrapper-' + facet_name + '" data-for="' + facet_name + '"></div>');
        facet.before('<a class="facet-collapse-link collapsed" data-for="' + facet_name + '" data-bs-toggle="collapse" href="#collapse_facet_' + facet_name + '" role="button" aria-expanded="false" aria-controls="collapse_facet_' + facet_name + '"><p class="h4 facet-label" data-for="' + facet_name + '">' + facet_label + ' <i class="w-icon-angle-down" aria-hidden="true"></i></p></a>');
        facet.wrap('<div class="collapse facet-collapse" data-for="' + facet_name + '" id="collapse_facet_' + facet_name + '"></div>');
      }
    }
  });
});
document.addEventListener('facetwp-loaded', function() {
  $.each(FWP.settings.num_choices, function(key, val) {

    // assuming each facet is wrapped within a "facet-wrap" container element
    // this may need to change depending on your setup, for example:
    // change ".facet-wrap" to ".widget" if using WP text widgets

    var $facet = $('.facetwp-facet-' + key);
    var $wrap = $facet.closest('.facet-wrap');
    var $flyout = $facet.closest('.flyout-row');
    if ($wrap.length || $flyout.length) {
      var $which = $wrap.length ? $wrap : $flyout;
      (0 === val) ? $which.hide() : $which.show();
    }
  });
});

$(document).on('facetwp-loaded', function(){
  if ($('.facetwp-checkbox').hasClass('checked')){
    $('.facetwp-checkbox.checked').closest('.facet-wrap').find('.facet-collapse-link').removeClass('collapsed');
    $('.facetwp-checkbox.checked').closest('.facet-collapse').addClass('show');
  }
});
$(document).on('facetwp-loaded', function(){
  if ($('.sidebar-content').hasClass('show')){
    $('.sidebar-close').trigger('click');
  }
});



$(document).on('facetwp-refresh', function() {
  if (FWP.loaded) {
    $('.loader-container').css('display', 'block');
  }
});

$(document).on('facetwp-loaded', function() {
  $('.loader-container').css('display', 'none');
});




$(function() 
{
	$.each($('.overflowToggler'), function (index, item)
	{
		overflowTogglerInitialize($(item));
	});
	
	jQuery.fn.extend(
	{
		overflowToggler: function() 
		{
			if(this == null)
				return;
			
			if(this.length == 1)
				overflowTogglerInitialize(this);
			else
			{
				var length = this.length;
				for(var i = 0; i < length; i++)
				{
					overflowTogglerInitialize($(this[i]));
				}
			}
		}
	});
});

function overflowTogglerInitialize(item)
{
	//handles situations where there was previously no overflow, but now there is overflow
	function handleNewOverflow(item)
	{
		var container = $("<div>").addClass("overflowToggler-container");
		
		item.before(container);
		container.append(item);
		
		var toggle = $("<div>").addClass("overflowToggler-toggler").addClass("closed");
		var toggleIcon = $("<div>").addClass("overflowToggler-toggleIcon");
		toggleIcon.append($("<span>").text("Show more"));
		toggleIcon.append($("<i>").addClass("w-icon-angle-down").attr("aria-hidden", "true"));

		item.parent().append($("<div>").addClass("overflowToggler-contentSpacer"));

		toggle.append(toggleIcon);
		item.parent().append(toggle);
		item.parent().addClass("closed");
		item.parent()[0].style.setProperty(
			"--overflowToggler-expanded-height",
			item[0].scrollHeight + 12 + "px"
		);

		toggle.click(function ()
		{
			var content = $(this).siblings(".overflowToggler-content");
			$(this).parent()[0].style.setProperty(
				"--overflowToggler-expanded-height",
				content[0].scrollHeight + 12 + "px"
			);
			$(this).toggleClass("open closed");
			$(this).parent().toggleClass("open closed");
			$(this).find(".overflowToggler-toggleIcon span").text(
				$(this).hasClass("open") ? "Show less" : "Show more"
			);
		});
	}
	
	//if the item hasn't been initialized yet
	if(item.hasClass('overflowToggler') || !item.hasClass("overflowToggler-content"))
	{
		item.addClass("overflowToggler-content");
		
		//if there's overflow
		if (hasVerticalOverflow(item[0]))
			handleNewOverflow(item);

		// Reveal only after the collapsed structure is ready to avoid page-load flicker.
		item.removeClass('overflowToggler');
	}
	else	//already initialized
	{
		var container = item.parent();
		var toggler = container.find("> .overflowToggler-toggler");
		
		//if there wasn't overflow last time it was initialized
		if(toggler == null || toggler.length == 0)
			handleNewOverflow(item);
		else //there was overflow last time it was initialized
		{
			//close it if it was open
			if(toggler.hasClass("open"))
			{
				toggler.toggleClass("open closed");
				toggler.parent().toggleClass("open closed");
			}
			
			//if there's no overflow now
			if (!hasVerticalOverflow(item[0]))
			{
				container.after(item);
				container.remove();
			}
		}
	}
}

function hasVerticalOverflow(element)
{
	return element.scrollHeight > element.clientHeight;
}



}(jQuery));

            

var thermotileStickySidebarArchiveReady = false;
var thermotileStickySidebarImageRefreshPending = false;

var is_thermotile_sticky_debug = function() {
  var hasQueryFlag = window.location.search.indexOf('sticky_debug=1') !== -1;

  try {
    if (hasQueryFlag) {
      window.localStorage.setItem('thermotileStickyDebug', '1');
    } else if (window.location.search.indexOf('sticky_debug=0') !== -1) {
      window.localStorage.removeItem('thermotileStickyDebug');
    }

    return hasQueryFlag || window.localStorage.getItem('thermotileStickyDebug') === '1';
  } catch (error) {
    return hasQueryFlag;
  }
};

var thermotile_sticky_debug_rect = function(element) {
  if (!element) {
    return null;
  }

  var rect = element.getBoundingClientRect();
  var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
  var scrollLeft = window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0;

  return {
    top: Math.round(rect.top),
    bottom: Math.round(rect.bottom),
    left: Math.round(rect.left),
    width: Math.round(rect.width),
    height: Math.round(rect.height),
    pageTop: Math.round(rect.top + scrollTop),
    pageBottom: Math.round(rect.bottom + scrollTop),
    pageLeft: Math.round(rect.left + scrollLeft),
  };
};

var thermotile_sticky_debug_snapshot = function(item, sidebar, instance, label, force) {
  if ((!force && !is_thermotile_sticky_debug()) || !window.console || !sidebar) {
    return null;
  }

  instance = instance || sidebar.__thermotileStickySidebar || null;

  var dims = instance && instance.dimensions ? Object.assign({}, instance.dimensions) : {};
  var inner = instance && instance.sidebarInner ? instance.sidebarInner : sidebar.querySelector('.inner-wrapper-sticky');
  var container = instance && instance.container ? instance.container : null;
  var affixStartTop = typeof dims.sidebarTop === 'number' ? dims.sidebarTop : dims.containerTop;
  var expectedAffixAt = typeof affixStartTop === 'number' && typeof dims.topSpacing === 'number'
    ? Math.round(affixStartTop - dims.topSpacing)
    : null;

  var data = {
    label: label,
    id: item.id,
    selector: item.selector,
    path: window.location.pathname + window.location.search,
    readyState: document.readyState,
    scrollY: Math.round(window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0),
    viewportHeight: window.innerHeight,
    affixedType: instance ? instance.affixedType : null,
    direction: instance ? instance.direction : null,
    expectedAffixAt: expectedAffixAt,
    dimensions: dims,
    rects: {
      container: thermotile_sticky_debug_rect(container),
      sidebar: thermotile_sticky_debug_rect(sidebar),
      inner: thermotile_sticky_debug_rect(inner),
      mainContent: thermotile_sticky_debug_rect(document.getElementById('main-content')),
      productCategories: thermotile_sticky_debug_rect(document.getElementById('ProductCategories')),
      brandSlider: thermotile_sticky_debug_rect(document.getElementById('BrandSlider')),
      teaser: thermotile_sticky_debug_rect(document.querySelector('.teaser--big')),
    },
    inlineStyles: {
      sidebar: sidebar.getAttribute('style') || '',
      inner: inner ? inner.getAttribute('style') || '' : '',
    },
  };

  if (typeof window.console.groupCollapsed === 'function') {
    window.console.groupCollapsed('[sticky-debug] ' + label + ' ' + item.id + ' ' + (data.affixedType || ''));
    window.console.log(data);
    window.console.groupEnd();
  } else {
    window.console.log('[sticky-debug]', data);
  }

  return data;
};

var bind_thermotile_sticky_debug = function(item, sidebar) {
  if (!is_thermotile_sticky_debug() || !sidebar || sidebar.__thermotileStickyDebugBound) {
    return;
  }

  sidebar.__thermotileStickyDebugBound = true;

  [
    'affix.static.stickySidebar',
    'affixed.static.stickySidebar',
    'affix.top.stickySidebar',
    'affixed.top.stickySidebar',
    'affix.bottom.stickySidebar',
    'affixed.bottom.stickySidebar',
    'affix.unbottom.stickySidebar',
    'affixed.unbottom.stickySidebar',
    'affix.container-bottom.stickySidebar',
    'affixed.container-bottom.stickySidebar',
  ].forEach(function(eventName) {
    sidebar.addEventListener(eventName, function() {
      thermotile_sticky_debug_snapshot(item, sidebar, sidebar.__thermotileStickySidebar, eventName);
    });
  });
};

window.thermotileStickyDebugSnapshot = function(selector) {
  var sidebar = document.querySelector(selector || '.sticky-content');
  var item = sidebar && sidebar.matches('.sticky-content-right')
    ? { id: 'right-sidebar', selector: '.sticky-content-right' }
    : { id: 'left-sidebar', selector: '.sticky-content' };

  return thermotile_sticky_debug_snapshot(item, sidebar, sidebar && sidebar.__thermotileStickySidebar, 'manual', true);
};

window.thermotileStickyDebugSnapshotJson = function(selector) {
  return JSON.stringify(window.thermotileStickyDebugSnapshot(selector), null, 2);
};

var update_sticky_sidebar_instance = function(instance) {
  if (!instance) {
    return;
  }

  if (typeof instance.updateSticky === 'function') {
    instance.updateSticky();
  } else if (typeof instance.update === 'function') {
    instance.update();
  }
};

var is_sticky_sidebar_archive = function() {
  return !!document.querySelector('.products__grid.facetwp-template');
};

var has_sticky_sidebar_instance = function() {
  return !!document.querySelector('.sticky-content.__thermotile-sticky-initialized, .sticky-content-right.__thermotile-sticky-initialized');
};

var wait_for_sticky_sidebar_layout = function(callback) {
  var attempts = 0;
  var stable = 0;
  var lastMeasure = '';

  var measure = function() {
    var row = document.getElementById('main-content');
    var sidebar = document.querySelector('.sticky-content');
    var grid = document.querySelector('.products__grid');
    var primary = document.getElementById('primary');

    return [
      row ? row.offsetHeight : 0,
      sidebar ? sidebar.offsetHeight : 0,
      grid ? grid.offsetHeight : 0,
      primary ? primary.offsetHeight : 0,
    ].join(':');
  };

  var check = function() {
    var currentMeasure = measure();

    attempts += 1;
    stable = currentMeasure === lastMeasure ? stable + 1 : 0;
    lastMeasure = currentMeasure;

    if (stable >= 2 || attempts >= 12) {
      callback();
      return;
    }

    window.setTimeout(function() {
      window.requestAnimationFrame(check);
    }, 50);
  };

  window.requestAnimationFrame(check);
};

var get_sticky_container_selector = function(sidebar, preferredSelector, fallbackId) {
  var container = preferredSelector && sidebar.closest(preferredSelector);

  if (!container) {
    container = sidebar.closest('.row');
  }

  if (!container) {
    return '.widget-area';
  }

  if (!container.id) {
    container.id = fallbackId;
  }

  return '#' + container.id;
};

var sticky_sidebar = function($){
  if (!window.StickySidebar) {
    return;
  }

  var sidebars = [
    { id: 'left-sidebar', selector: '.sticky-content', containerSelector: '#main-content' },
    { id: 'right-sidebar', selector: '.sticky-content-right', containerSelector: null }
  ];

  sidebars.forEach(function(item) {
    var stc = document.getElementById(item.id);
    var sidebar = document.querySelector(item.selector);

    if (stc !== null && sidebar) {
      if (!sidebar.__thermotileStickySidebar) {
        sidebar.classList.add('__thermotile-sticky-initialized');
        sidebar.__thermotileStickySidebar = new StickySidebar(item.selector, {
          topSpacing: 80,
          bottomSpacing: 60,
          containerSelector: get_sticky_container_selector(sidebar, item.containerSelector, item.id + '-sticky-container'),
          minWidth: 992,
          resizeSensor: true,
        });
        bind_thermotile_sticky_debug(item, sidebar);
        thermotile_sticky_debug_snapshot(item, sidebar, sidebar.__thermotileStickySidebar, 'created');
      } else {
        update_sticky_sidebar_instance(sidebar.__thermotileStickySidebar);
        bind_thermotile_sticky_debug(item, sidebar);
        thermotile_sticky_debug_snapshot(item, sidebar, sidebar.__thermotileStickySidebar, 'updated');
      }
    }
  });
};

var observe_sticky_sidebar_template = function($) {
  var template = document.querySelector('.facetwp-template');

  if (!template || !window.MutationObserver || template.__thermotileStickySidebarObserver) {
    return;
  }

  template.__thermotileStickySidebarObserver = new MutationObserver(function() {
    if (is_sticky_sidebar_archive() && !thermotileStickySidebarArchiveReady && !has_sticky_sidebar_instance()) {
      return;
    }

    schedule_sticky_sidebar($);
  });
  template.__thermotileStickySidebarObserver.observe(template, {
    childList: true,
  });
};

var refresh_sticky_sidebar_after_images = function($) {
  var grid = document.querySelector('.products__grid');

  if (!grid) {
    return;
  }

  if (thermotileStickySidebarImageRefreshPending) {
    return;
  }

  thermotileStickySidebarImageRefreshPending = true;

  var complete = function() {
    thermotileStickySidebarImageRefreshPending = false;
    sticky_sidebar($);
  };

  if ($ && $.fn && $.fn.imagesLoaded) {
    $(grid).imagesLoaded(complete);
  } else if (window.imagesLoaded) {
    window.imagesLoaded(grid, complete);
  } else {
    complete();
  }
};

var refresh_sticky_sidebar = function($, options) {
  options = options || {};

  var refresh = function() {
    sticky_sidebar($);
    observe_sticky_sidebar_template($);

    if (!options.skipImageRefresh) {
      refresh_sticky_sidebar_after_images($);
    }
  };

  if (options.waitForLayout) {
    wait_for_sticky_sidebar_layout(refresh);
  } else {
    refresh();
  }
};

var schedule_sticky_sidebar = function($, options) {
  options = options || {};

  var schedule = window.thermotileScheduleAfterFirstPaint || function(callback) {
    requestAnimationFrame(function() {
      requestAnimationFrame(callback);
    });
  };

  schedule(function() {
    refresh_sticky_sidebar($, options);
  });

  if (options.delayed === false) {
    return;
  }

  window.setTimeout(function() {
    refresh_sticky_sidebar($);
  }, 200);

  window.setTimeout(function() {
    refresh_sticky_sidebar($);
  }, 650);
};

jQuery(document).ajaxComplete(function() {
  // Ensure $ is defined inside the callback
  var $ = jQuery;

  if (!is_sticky_sidebar_archive() || has_sticky_sidebar_instance()) {
    schedule_sticky_sidebar($);
  }
});

jQuery(document).ready(function($) {
  observe_sticky_sidebar_template($);

  if (!is_sticky_sidebar_archive()) {
    schedule_sticky_sidebar($, {
      waitForLayout: true,
      skipImageRefresh: true,
      delayed: false,
    });
  }
});


// FacetWP AJAX Refresh (Recommended for FacetWP AJAX)
jQuery(document).on('facetwp-loaded', function() {
  var isInitialArchiveRender = !thermotileStickySidebarArchiveReady;

  thermotileStickySidebarArchiveReady = true;
  schedule_sticky_sidebar(jQuery, isInitialArchiveRender ? {
    waitForLayout: true,
    skipImageRefresh: true,
    delayed: false,
  } : {});
});

jQuery(window).on('load', function() {
  if (is_sticky_sidebar_archive() && !has_sticky_sidebar_instance()) {
    thermotileStickySidebarArchiveReady = true;
    schedule_sticky_sidebar(jQuery, {
      waitForLayout: true,
      skipImageRefresh: true,
      delayed: false,
    });
  }
});

// Before and after image comparison slider
document.querySelectorAll('.compare-slider').forEach(slider => {
  const handle = slider.querySelector('.slider-handle');
  const before = slider.querySelector('.before-image');

  if (!handle || !before) {
    return;
  }

  let isDragging = false;
  let currentPercent = 0.50; // Start at 50%
  let sliderRect = slider.getBoundingClientRect();
  let resizeTicking = false;

  handle.style.left = '0';

  const refreshSliderRect = () => {
    sliderRect = slider.getBoundingClientRect();
  };

  const setClipPercent = (percent) => {
    percent = Math.min(Math.max(percent, 0), 1);
    currentPercent = percent; // Save current percent for resize

    const pos = sliderRect.width * percent;

    // Move handle (centered) without changing layout.
    handle.style.transform = `translateX(calc(${pos}px - 50%))`;

    // Keep the image and both label layers clipped to the same divider.
    slider.style.setProperty('--compare-position', `${percent * 100}%`);
  };

  // Initial setup
  window.requestAnimationFrame(() => {
    refreshSliderRect();
    setClipPercent(currentPercent);
  });

  // ✅ CLICK ANYWHERE
  slider.addEventListener('click', (e) => {
    refreshSliderRect();
    setClipPercent((e.clientX - sliderRect.left) / sliderRect.width);
  });

  // ✅ DRAG START (handle only)
  handle.addEventListener('mousedown', (e) => {
    e.preventDefault();
    refreshSliderRect();
    isDragging = true;
  });

  // ✅ DRAG MOVE
  window.addEventListener('mousemove', (e) => {
    if (!isDragging) return;
    setClipPercent((e.clientX - sliderRect.left) / sliderRect.width);
  });

  // ✅ DRAG END
  window.addEventListener('mouseup', () => {
    isDragging = false;
  });

  // ✅ TOUCH SUPPORT
  slider.addEventListener('touchstart', (e) => {
    refreshSliderRect();
    setClipPercent((e.touches[0].clientX - sliderRect.left) / sliderRect.width);
    isDragging = true;
  });

  window.addEventListener('touchmove', (e) => {
    if (!isDragging) return;
    setClipPercent((e.touches[0].clientX - sliderRect.left) / sliderRect.width);
  });

  window.addEventListener('touchend', () => {
    isDragging = false;
  });

  // ✅ FIX ON RESIZE
  window.addEventListener('resize', () => {
    if (resizeTicking) {
      return;
    }

    resizeTicking = true;
    window.requestAnimationFrame(() => {
      resizeTicking = false;
      refreshSliderRect();
      setClipPercent(currentPercent); // Reapply clip based on saved percent
    });
  }, { passive: true });
});


// Replace MailPoet's submit input with the theme's icon button.
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".newsletter-box form").forEach((form) => {
    const input = form.querySelector('input[type="submit"]');

    if (!input) {
      return;
    }

    const label = input.value || input.getAttribute("aria-label") || "Subscribe";
    const button = document.createElement("button");
    const icon = document.createElement("i");
    const hiddenLabel = document.createElement("span");

    button.type = "submit";
    button.className = "btn btn-contained w-auto border-0 m-0 px-3 py-2 lh-lg";
    button.setAttribute("aria-label", label);

    icon.className = "w-icon-long-arrow-right fs-4 p-0 fw-light";
    icon.setAttribute("aria-hidden", "true");

    hiddenLabel.className = "visually-hidden";
    hiddenLabel.textContent = label;

    button.append(icon, hiddenLabel);
    input.replaceWith(button);
  });
});

// Business hours script
document.addEventListener("DOMContentLoaded", function () {
    const statusEl = document.getElementById("business-status");
    const headerContact = document.querySelector(".header__contact");
    const stateEls = [headerContact, statusEl].filter(Boolean);
    const phoneLinks = [
        ...Array.from(headerContact?.querySelectorAll('a[href^="tel:"], a[href^="whatsapp:"]') || []),
        ...Array.from(statusEl?.closest(".phone")?.querySelectorAll("a") || [])
    ];

    if (!stateEls.length) {
        return;
    }

    const isGreek = document.documentElement.lang.toLowerCase().startsWith("el");
    const businessStatusText = isGreek
        ? {
            closed: "Αυτή τη στιγμή κλειστό",
            dayLabels: ["Κυριακή", "Δευτέρα", "Τρίτη", "Τετάρτη", "Πέμπτη", "Παρασκευή", "Σάββατο"],
            opensAt: (dayLabel, time) => `Ανοιχτά από ${dayLabel}${dayLabel ? " " : ""}${time}`,
            openUntil: (time) => `Ανοιχτά έως τις ${time}`
        }
        : {
            closed: "Aktualisht e mbyllur",
            dayLabels: ["e Diela", "e Hëna", "e Marta", "e Mërkura", "e Enjtja", "e Premtja", "e Shtuna"],
            opensAt: (dayLabel, time) => `Në dispozicion nga ${dayLabel}${dayLabel ? " " : ""}${time}`,
            openUntil: (time) => `Në dispozicion deri në ${time}`
        };

    const setPhoneHref = (href) => {
        phoneLinks.forEach((link) => {
            link.setAttribute("href", href);
        });
    };

    const addState = (state) => {
        stateEls.forEach((el) => {
            el.classList.toggle("open", state === "open");
            el.classList.toggle("before-open", state === "before-open");
            el.classList.toggle("closed", state === "closed");
        });
    };

    const fallbackHours = [
        null,
        { open: "08:30", close: "19:00" },
        { open: "08:30", close: "19:00" },
        { open: "08:30", close: "19:00" },
        { open: "08:30", close: "19:00" },
        { open: "08:30", close: "19:00" },
        { open: "08:30", close: "16:00" }
    ];
    let hours = fallbackHours;

    try {
        const configuredHours = JSON.parse(headerContact?.dataset.businessHours || "");

        if (Array.isArray(configuredHours) && configuredHours.length === 7) {
            hours = configuredHours;
        }
    } catch (error) {
        hours = fallbackHours;
    }

    const timeToMinutes = (time) => {
        const [hour, minute] = String(time || "").split(":").map(Number);

        return Number.isFinite(hour) && Number.isFinite(minute) ? (hour * 60) + minute : null;
    };

    const now = new Date();
    const day = now.getDay();
    const currentMinutes = (now.getHours() * 60) + now.getMinutes();
    const todayHours = hours[day];
    const openingMinutes = timeToMinutes(todayHours?.open);
    const closingMinutes = timeToMinutes(todayHours?.close);
    const isOpen = openingMinutes !== null && closingMinutes !== null && currentMinutes >= openingMinutes && currentMinutes < closingMinutes;
    const isBeforeOpen = openingMinutes !== null && currentMinutes >= (openingMinutes - 60) && currentMinutes < openingMinutes;
    const phoneHref = headerContact?.dataset.phoneHref || "tel:+355694067100";
    const whatsappHref = headerContact?.dataset.whatsappHref || "https://wa.me/355694067100";

    const getNextOpening = () => {
        for (let offset = 0; offset < 7; offset += 1) {
            const nextDay = (day + offset) % 7;
            const nextHours = hours[nextDay];
            const nextOpeningMinutes = timeToMinutes(nextHours?.open);

            if (nextOpeningMinutes === null || (offset === 0 && currentMinutes >= nextOpeningMinutes)) {
                continue;
            }

            return { day: nextDay, offset, time: nextHours.open };
        }

        return null;
    };

    if (isOpen) {
        if (statusEl) {
            statusEl.textContent = businessStatusText.openUntil(todayHours.close);
        }
        addState("open");
        setPhoneHref(phoneHref);
    } else {
        const nextOpening = getNextOpening();

        if (statusEl) {
            statusEl.textContent = nextOpening
                ? businessStatusText.opensAt(
                    nextOpening.offset === 0 ? "" : businessStatusText.dayLabels[nextOpening.day],
                    nextOpening.time
                )
                : businessStatusText.closed;
        }
        addState(isBeforeOpen ? "before-open" : "closed");
        setPhoneHref(whatsappHref);
    }
});
